export default __webpack_public_path__ + "static/media/landingpage_elementos-06.2a98564a.png";